import FormPassword from './FormPassword';


export default FormPassword;
